/* istanbul ignore file */
import { PermissionsMap } from '../utils';

export const SET_GLOBAL_PERMISSIONS = 'authorization/globalPermissions';

export const setGlobalPermissions = (payload: PermissionsMap) => ({
  type: SET_GLOBAL_PERMISSIONS,
  payload,
});
